import { Resource } from "src/app/global/domain/resource.model";

export class Parcela extends Resource {
  ordem: number;
  valor: number;
  valorPago: number;
  dataAgendamento: Date;
  totalValorPago : number;
}
  